<div class="flex flex-col w-full h-full bg-white rounded-2xl overflow-hidden">
    <!-- Header -->
    <div class="flex justify-between items-center px-6 py-5 border-b border-gray-200">
        <h2 class="text-[20px] font-semibold font-inter text-gray-900 m-0">Alterar senha</h2>
        <button mat-icon-button (click)="closeModal()" class="w-9 h-9 text-gray-500 hover:bg-gray-100 hover:text-gray-900 transition-all duration-200">
            <mat-icon class="icon-size-6" [svgIcon]="'mat_outline:close'"></mat-icon>
        </button>
    </div>

    <!-- Content -->
    <div class="flex-1 p-6 pb-[86px] overflow-y-auto">
        <form [formGroup]="changePasswordForm">
            <!-- Senha Atual -->
            <mat-form-field class="w-full">
                <mat-label>Senha atual</mat-label>
                <input
                    matInput
                    [type]="showCurrentPassword ? 'text' : 'password'"
                    formControlName="currentPassword"
                    placeholder="Digite sua senha atual">
                <button
                    mat-icon-button
                    matSuffix
                    type="button"
                    (click)="togglePasswordVisibility('current')">
                    <mat-icon class="icon-size-5" [svgIcon]="showCurrentPassword ? 'mat_outline:visibility_off' : 'mat_outline:visibility'"></mat-icon>
                </button>
                <mat-icon class="icon-size-5" matPrefix [svgIcon]="'mat_outline:lock'"></mat-icon>
            </mat-form-field>

            <!-- Nova Senha -->
            <mat-form-field class="w-full mt-4">
                <mat-label>Nova senha</mat-label>
                <input
                    matInput
                    [type]="showNewPassword ? 'text' : 'password'"
                    formControlName="newPassword"
                    placeholder="Digite sua nova senha">
                <button
                    mat-icon-button
                    matSuffix
                    type="button"
                    (click)="togglePasswordVisibility('new')">
                    <mat-icon class="icon-size-5" [svgIcon]="showNewPassword ? 'mat_outline:visibility_off' : 'mat_outline:visibility'"></mat-icon>
                </button>
                <mat-icon class="icon-size-5" matPrefix [svgIcon]="'mat_outline:lock'"></mat-icon>
                <mat-error *ngIf="changePasswordForm.get('newPassword')?.hasError('minlength')">
                    A senha deve ter no mínimo 6 caracteres
                </mat-error>
            </mat-form-field>

            <!-- Repetir Senha -->
            <mat-form-field class="w-full mt-4">
                <mat-label>Repetir nova senha</mat-label>
                <input
                    matInput
                    [type]="showConfirmPassword ? 'text' : 'password'"
                    formControlName="confirmPassword"
                    placeholder="Digite novamente sua nova senha">
                <button
                    mat-icon-button
                    matSuffix
                    type="button"
                    (click)="togglePasswordVisibility('confirm')">
                    <mat-icon class="icon-size-5" [svgIcon]="showConfirmPassword ? 'mat_outline:visibility_off' : 'mat_outline:visibility'"></mat-icon>
                </button>
                <mat-icon class="icon-size-5" matPrefix [svgIcon]="'mat_outline:lock'"></mat-icon>
                <mat-error *ngIf="changePasswordForm.hasError('passwordMismatch') && changePasswordForm.get('confirmPassword')?.touched">
                    As senhas não coincidem
                </mat-error>
            </mat-form-field>
        </form>
    </div>

    <!-- Footer -->
    <div class="absolute flex bottom-0 left-0 right-0 p-6 w-full flex-row-reverse bg-white border-t border-gray-200">
        <div class="relative w-[118px] h-[38px]">
            <button
                [disabled]="changePasswordForm.invalid || loading"
                (click)="savePassword()"
                class="w-full h-full flex px-6 py-2 rounded-3xl bg-[#0061ff] hover:bg-[#2f75e7] relative cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed">
                <span class="mr-2 font-remote font-[400] text-[15px] text-white" *ngIf="!loading">Salvar</span>
                <mat-icon class="icon-size-5 text-white relative" [svgIcon]="'mat_solid:save'" *ngIf="!loading"></mat-icon>
                <mat-progress-spinner *ngIf="loading" [diameter]="18" [mode]="'indeterminate'" class="m-auto spinner-white"></mat-progress-spinner>
            </button>
        </div>
    </div>
</div>
